import { type } from "../charge/utils";
import { isPlainObject, getValueAtPath } from "../utils";
import { falseFunction } from "./helpers";
import Fetcher from "../fetcher";
import {
    DEFAULT_RETRY_CONDITIONS,
    DEFAULT_TIMEOUT,
    isJsonResponse,
    withSharedHeaders
} from "../fetcher/utils";

const accountNumber = 'Account number';
const mobileNumber = 'Mobile number';

const capitecPaymentOptions = Object.freeze([
    { name: accountNumber, identifier: accountNumber, label: accountNumber },
    { name: mobileNumber, identifier: mobileNumber, label:  mobileNumber},
]);

const $fetch = withSharedHeaders(Fetcher.one
    .limit(3)
    .retry(...DEFAULT_RETRY_CONDITIONS)
    .timeout(DEFAULT_TIMEOUT));

function selectCapitecPaymentOptionFromList(list, capitecOption) {
    if (type(list) !== 'array') return null;

    if (list.indexOf(capitecOption) < 0) {
        const capitecOptionObject = isPlainObject(capitecOption);

        const { name: capitecOptionName, identifier: capitecOptionIdentifier } =
        capitecOptionObject
            ? capitecOption
            : (capitecOption = String(capitecOption), { name: capitecOption, identifier: capitecOption });

        capitecOption = list.find(item => {
            if (isPlainObject(item)) {
                const { name, identifier } = item;

                const hasName = typeof capitecOptionName !== 'undefined';
                const hasIdentifier = typeof capitecOptionIdentifier !== 'undefined';

                let matches = (hasName || hasIdentifier) ? 1 : 0;

                if (capitecOptionObject) {
                    hasName && (matches = matches & (capitecOptionName === name));
                    hasIdentifier && (matches = matches & (capitecOptionIdentifier === identifier));
                } else {
                    matches = matches & (
                        hasName && capitecOptionName === name || 
                        hasIdentifier && capitecOptionIdentifier === identifier
                    );
                }

                return matches;
            }
        });
    }
    return capitecOption || null;
}
// Temporarily remove check for high risk merchant implementation
// function getMerchantCategory(context) {
    // return $fetch(new URL(`/flwv3-pug/getpaidx/api/merchant_category_status?PBFPubKey=${getValueAtPath(context, 'DATA.PBFPubKey')}`, process.env.API_BASE_URL))
    //     .then(response => {
    //         if (isJsonResponse(response) && response.ok) {
    //             return response.json()
    //                 .then(response => {
    //                     const { status } = { ...response.data };
    //                     return status;
    //                 })
    //         }
    //     }).catch(falseFunction)
// }

export {
    capitecPaymentOptions,
    selectCapitecPaymentOptionFromList,
    // getMerchantCategory
}